/**
 * @param {HTMLElement} item
 * @param {'top'|'bottom'}position
 */

export function naturalSticky(item, position = 'top') {
  if (!item) {
    return
  }

  item.classList.add('stickyable')
  let lastScrollTop = 0
  let initialPosition = computeDefaultPosition(item)

  const onScroll = function () {
    // or window.addEventListener("scroll"....
    const st = window.pageYOffset || document.documentElement.scrollTop // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

    item.style.setProperty(position, '0')

    if (st > lastScrollTop) {
      if (st > item.clientHeight) {
        item.classList.remove('sticky')
        item.classList.add('sticky-hidden')
      }

      if (st < initialPosition) {
        item.classList.remove('sticky', 'sticky-hidden')
        item.style.removeProperty(position)

        return null
      }
    } else if (st < lastScrollTop) {
      item.classList.remove('sticky-hidden')
      item.classList.add('sticky')
    }

    lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
  }

  window.addEventListener('scroll', onScroll, false)
  onScroll()
}

function createObserver(boxElement, handleIntersect) {
  return new IntersectionObserver(handleIntersect, {
    root: null,
    rootMargin: '0px',
  })
}

function computeDefaultPosition(item) {
  let pos = item.style.position
  let transition = item.style.transition
  item.style.position = 'initial'
  item.style.transition = 'none'
  window.getComputedStyle(item) // Force redraw

  let box = item.getBoundingClientRect()
  let initialPosition =
    box.top +
    box.height +
    (window.pageYOffset || document.documentElement.scrollTop)

  if (pos !== null) {
    item.style.position = pos
  } else {
    item.style.removeProperty('position')
  }
  if (transition) {
    item.style.transition = transition
  } else {
    item.style.removeProperty('transition')
  }
  window.getComputedStyle(item) // Force redraw

  return initialPosition
}
